
import {initWebComponent} from "@/helpers/web-component-helper";


export class LayerInfoToolsSwitcherButtonComponent extends HTMLElement {
    constructor(){
        super();

        const title = this.getAttribute('data-title')
        const icon = this.getAttribute('data-icon')

        const template = document.createElement('template');
        template.innerHTML = `
        <input type="radio" value="` + title + `" name="rdiTools">
        <i class="` +  icon + `"></i>
        <layout-language data-key="` +  title + `"></layout-language>
       ` ;


        initWebComponent(this, template)
    }
}

